import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import { useDispatch } from 'react-redux';
import _get from 'lodash/get';
import { showRegionSelector, setRegion } from 'containers/Main/actions';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    padding: '0 18px',
    '& span': {
      flexDirection: 'column',
      alignItems: 'center',
    },
    '&:hover': {
      background: 'transparent',
    },
    '& :focus': {
      background: 'transparent',
    },
  },
  title: {
    ...theme.typography.pxSmall,
    color: theme.palette.primary.main,
  },
  img: {
    height: 43,
  },
}));

const RegionsCard = ({ data }) => {
  const {
    fields: { slug },
    fields,
  } = data;
  const image = _get(fields, 'image.fields');
  const classes = useStyles();
  const dispatch = useDispatch();
  if (!image) return null;
  const {
    title,
    file: { url },
  } = image;
  const selectRegion = () => {
    dispatch(showRegionSelector(false));
    dispatch(setRegion(slug));
  };
  return (
    <IconButton className={classes.root} onClick={selectRegion}>
      <img src={url} alt={title} className={classes.img} />
      <span className={classes.title}>{title}</span>
    </IconButton>
  );
};

RegionsCard.propTypes = {
  data: PropTypes.object,
};
export default RegionsCard;
